import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IHelpDocumentsState } from './help-documents.state';

export const selectHelpDocumentsState =
  createFeatureSelector<IHelpDocumentsState>('helpDocuments');

export const selectHelpDocuments = createSelector(
  selectHelpDocumentsState,
  (state) => state.documents
);

export const selectHelpDocumentsLoading = createSelector(
  selectHelpDocumentsState,
  (state) => state.loading
);
